import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { TimelineHeaderContainer } from './styles';
import { setPickedDate } from 'redux/actions'
import { useDispatch } from 'react-redux'
import colors from 'constants/colors'
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const TimelineHeader = ({
  intervals,
  getRootProps,
  getIntervalProps,
}) => {

  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate)
  const dispatch = useDispatch()
  const cellRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = cellRef.current;
    if (!el) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setIsOverflowing(entry.contentRect.width < 80);
      }
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <TimelineHeaderContainer {...getRootProps()}>
      {
        intervals.map((interval) => {
          const intervalStyle = {
            height: '50px',
            textAlign: 'left',
            borderTop: `2px solid ${colors.dimGrey}`,
            borderBottom: `2px solid ${colors.dimGrey}`,
            borderRight: `1px solid ${colors.charcoal}`,
            cursor: 'pointer',
            backgroundColor: colors.black1,
            fontSize: '12px',
            fontWeight: 'bold',
            padding: '0 10px',
            letterSpacing: '1px',
            color: colors.silver,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          };

          const date = interval.startTime.format('MMM Do YYYY');
          const weekday = interval.startTime.format('dddd');

          return (
            <div
              className={moment(pickedDate).tz(TIME_ZONE).format('MMM Do YYYY') === date ? 'today': null}
              ref={cellRef}
              key={interval.startTime}
              onClick={() => {
                dispatch(setPickedDate(moment(interval.startTime).tz(TIME_ZONE).valueOf()))
              }} 
              {...getIntervalProps({
                interval,
                style: {
                  ...intervalStyle,
                },
              })}
            >
              <div className='timeline-header-cell'>
                {!isOverflowing && <div className='weekday'>{weekday}</div>}
                <div className='date'>{date}</div>
              </div>
            </div>
          )
        })
      }
    </TimelineHeaderContainer>
  );
};

export default TimelineHeader;
